import { NgModule, ErrorHandler } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { RouterModule } from "@angular/router";
import { AppInsightService } from "../logging/services/appinsights.service";
import { ErrorPageComponent } from "./error-page/error-page.component";
import { ErrorRoutingModule } from "./errors.routing.module";
import { ErrorsHandler } from "./services/errors.handler";
import { ServerErrorsInterceptor } from "./services/errors.interceptor";
import { ErrorsService } from "./services/errors.service";

@NgModule({
  imports: [CommonModule, RouterModule, ErrorRoutingModule],
  declarations: [ErrorPageComponent],
  providers: [
    ErrorsService,
    {
      provide: ErrorHandler,
      useClass: ErrorsHandler,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ServerErrorsInterceptor,
      multi: true,
    },
    AppInsightService,
  ],
})
export class ErrorsModule {}
